import { message } from "antd";
const simulatePrintDialog = (dataToExport, selectedColumns) => {
    // try{
    const printableContent = document.createElement("div");
    printableContent.style.width = "100%";
    printableContent.style.margin = "0 auto";
    printableContent.style.padding = "5px";
    printableContent.style.fontFamily = "Arial, sans-serif";
    printableContent.style.fontSize = "5px";
    const table = document.createElement("table");
    table.style.width = "100%";
    table.style.border = "1px solid #000";
    table.style.borderCollapse = "collapse";

    const thead = document.createElement("thead");
    const headerRow = document.createElement("tr");

    selectedColumns.forEach((col) => {
      const th = document.createElement("th");
      th.style.padding = "2px";
      th.style.textAlign = "left";
      th.style.border = "1px solid #ddd";
      th.innerText = col.toUpperCase();
      headerRow.appendChild(th);
    });
    thead.appendChild(headerRow);
    table.appendChild(thead);

    const tbody = document.createElement("tbody");
    dataToExport.forEach((row) => {
      const rowElement = document.createElement("tr");
      selectedColumns.forEach((col) => {
        const td = document.createElement("td");
        td.style.padding = "2px";
        td.style.textAlign = "left";
        td.style.border = "1px solid #ddd";
        td.innerText = row[col];
        rowElement.appendChild(td);
      });
      tbody.appendChild(rowElement);
    });

    table.appendChild(tbody);
    printableContent.appendChild(table);

    const printStyle = document.createElement("style");
    printStyle.innerHTML = `
      body * {
        visibility: hidden;
      }
      #print-content, #print-content * {
        visibility: visible;
      }
      #print-content {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
      }
      table {
        margin-top: 5px;
        width: 100%;
        border: 1px solid black;
        border-collapse: collapse;
      }
      th, td {
        padding: 2px;
        text-align: left;
        border: 1px solid #ddd;
      }
    `;
    document.head.appendChild(printStyle);

    printableContent.id = "print-content";
    document.body.appendChild(printableContent);

    window.print();

    document.body.removeChild(printableContent);
    document.head.removeChild(printStyle);
  };



export const handleExport = (fileFormat, columns,data) => {
    const selectedColumns =columns;
    let dataToExport = data;

    if (dataToExport?.length > 0) {
      if (fileFormat === "CSV") {
        const csvData = convertToCSV(dataToExport, selectedColumns);
        downloadCSV(csvData, `Report.csv`);
      } else if (fileFormat === "PDF") {
        simulatePrintDialog(dataToExport, selectedColumns);
      }
    } else {
      message.info({
        content: "No data available for export.",
        duration: 5,
        className: "custom-toast-center",
      });
    }
  };
  const convertToCSV = (responseArray, selectedColumns) => {
    // try{
    if (!responseArray || responseArray.length === 0) return "";

    const headers = selectedColumns.join(",") + "\n";

    const rows = responseArray
      .map((row) => {
        return selectedColumns
          .map((column) => {
            let value = row[column];

            if (
              typeof value === "number" ||
              (typeof value === "string" && value.length > 10)
            ) {
              value = value.toString().padEnd(15, " ");
            }

            const escapedValue = ("" + value).replace(/"/g, '""');
            return `"${escapedValue}"`;
          })
          .join(",");
      })
      .join("\n");

    return headers + rows;
  };

  const downloadCSV = (csv, filename) => {
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };